import { FormattedMessage } from 'react-intl';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { IconArrowRight } from '@xing-com/icons';

import {
  recommendationPagesWithNewsletter,
  RecommendationPageType,
} from '../../config';
import { Paths } from '../../paths';

import { pageInfoCopies } from './page-info-copies';
import * as Styled from './page-info.styles';

type PageInfoProps = {
  type: RecommendationPageType;
};

export const PageInfo: React.FC<PageInfoProps> = ({ type }) => {
  const { isLoggedIn } = useLoginState();
  const hasSettingsLink =
    recommendationPagesWithNewsletter.includes(type) && isLoggedIn;
  const isPremium = type === RecommendationPageType.PREMIUM;

  return (
    <Styled.PageInfoContainer $isLoggedIn={isLoggedIn}>
      <Styled.Hero size="medium" noMargin>
        <Styled.TitleWrapper $isPremium={isPremium}>
          <FormattedMessage id={pageInfoCopies[type].titleCopyId} />
        </Styled.TitleWrapper>
        {isPremium ? (
          <Styled.Flag
            size="medium"
            variant="premium"
            data-testid="recommendation-info-premium-flag"
          />
        ) : null}
      </Styled.Hero>
      <Styled.BodyCopy size="large">
        <FormattedMessage id={pageInfoCopies[type].descriptionCopyId} />
      </Styled.BodyCopy>
      {hasSettingsLink ? (
        <Styled.TextButton
          icon={IconArrowRight}
          fontWeight="regular"
          to={Paths.NEWSLETTER_SETTINGS}
        >
          <FormattedMessage id="FOLLOWING_RECOMMENDATION_PAGE_NEWSLETTER_SETTINGS" />
        </Styled.TextButton>
      ) : null}
    </Styled.PageInfoContainer>
  );
};
